import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  .line {
    stroke-width: 2px;
  }
  .domain {
    stroke: none;
  }
  .axis-grid .tick {
    line {
      stroke: rgba(255, 255, 255, 0.1);
      stroke-width: 2px;
    }
    text {
      color: #919eaa;
      font-size: 14px;
      transform: translateX(6px);
    }
  }
`;

export default Wrapper;
